import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Link } from "react-router-dom";
import axios from 'axios';
import moment from 'moment';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import GuestSiteMenu from "../guest_menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../App.css';
import ReactGA from "react-ga4";

function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY h:mm A');
}

class TrainingMainTemp extends React.Component {

    constructor(props) {
        super(props);
        let userExists = !(props.location.state == null || props.location.state.user == null || Object.keys(props.location.state.user).length === 0);
        let historyExists = !(props.history.location.state == null || props.history.location.state.data == null)
        this.state = {
            user: userExists ? props.location.state.user : {},
            userExists: userExists,
            availableData: historyExists ? props.history.location.state.data : [],
            availableLoading: false,
            completedData: historyExists ? props.history.location.state.data : [],
            completedLoading: false
        };

        this.handleTableChange = this.handleTableChange.bind(this);

        this.completedLoadingSpinner = this.completedLoadingSpinner.bind(this);
        this.availableLoadingSpinner = this.availableLoadingSpinner.bind(this);
        this.getAvailableTrainings = this.getAvailableTrainings.bind(this);
        //this.getCompletedTrainings = this.getCompletedTrainings.bind(this);

    }

    componentDidMount() {
        this.handleTableChange("search", this.state);
    }

    completedLoadingSpinner() {
        if (this.state.completedLoading) {
            return <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>;
        }
        else {
            return 'We don’t have any trainings on file for you yet. Register above or email us at marketing@boland.com with questions.';
        }
    };
    availableLoadingSpinner() {
        if (this.state.availableLoading) {
            return <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>;
        }
        else {
            return 'No available trainings.';
        }
    };

    getAvailableTrainings() {
        axios.get(`${Constants.apiURL}/api/Training/GetAvailableTraining`, {
            params: {
                user: this.state.user.username
            }
        }).then(response => {
            console.log(response);
            if (response.data) {
                this.setState(() => ({
                    availableData: response.data,
                    availableLoading: false
                }));
            }
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ availableLoading: false });
            console.log('request failed', response)
        });
    }
    /*
    getCompletedTrainings() {
        axios.get(`${Constants.apiURL}/api/Training/GetCompletedTraining`, {
            params: {
                user: this.state.user.username,
                email: this.state.user.email
            }
        }).then(response => {
            console.log(response);
            if (response.data) {

                this.setState(() => ({
                    completedData: response.data,
                    completedLoading: false
                }));
            }
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ completedLoading: false });
        });
    }*/

    handleTableChange = (type, { }) => {
        this.setState({
            availableLoading: true,
            availableData: [],
            completedLoading: true,
            completedData: []
        },
            function () {
                this.getAvailableTrainings();
                //this.getCompletedTrainings();
            });
    }

    handleAvaialblTableChange = (type, { sortField, sortOrder }) => {

        this.setState({
            loading: true,
            sortOrder,
            sortField
        },
        function () {
            axios.get(`${Constants.apiURL}/api/Training/GetAvailableTraining`, {
                params: {
                    user: this.state.user.username,
                    sortField: this.state.sortField,
                    sortOrder: this.state.sortOrder
                }
            }).then(response => {
                console.log(response);
                if (response.data) {
                    this.setState(() => ({
                        availableData: response.data,
                        availableLoading: false
                    }));
                }
            }).catch((response) => {
                if (response.response.status === 401) {
                    this.props.history.push({
                        pathname: '/'
                    });
                }
                // ? Show to user that request is failed
                this.setState({ errors: [response] })
                this.setState({ availableLoading: false });
                console.log('request failed', response)
            });
        });
    }


    render() {
        const availableColumns = [
            {
                text: 'Register',
                dataField: 'x',
                formatter: (cell, row) => {
                    return <Button style={{ backgroundColor: '#00973A', width: '100%' }} onClick={() => {
                        this.props.history.push({
                            pathname: "/training_registration",
                            search: "?id=" + row.Id,
                            state: {
                                user: this.state.user,
                                training: row
                            }
                        });
                    }}>Register</Button>
                },
                headerStyle: (colum, colIndex) => {
                    return { width: '130px', textAlign: 'center' };
                }
            },
            {
                text: 'Name',
                dataField: 'Name',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', width: '250px' };
                },
                style: {fontWeight:'bold'}
            },
            {
                text: 'Start',
                dataField: 'StartDate',
                sort: true,
               formatter: dateFormat,
                headerStyle: (colum, colIndex) => {
                    return { width: '100px', textAlign: 'center', wordBreak: 'break-all' };
                }
            },
            {
                text: 'End',
                dataField: 'EndDate',
                sort: true,
               formatter: dateFormat,
                headerStyle: (colum, colIndex) => {
                    return { width: '100px', textAlign: 'center', wordBreak: 'break-all' };
                }
            },
            {
                text: 'Location',
                dataField: 'Location',
                sort: true,
               headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', width:'250px', wordBreak: 'break-all' };
                }
            }];
        const { availableData, completedData } = this.state;


        const customStyle = {
            padding: '10px',
            margin: '10px'
        };
        return (
            <div class="training_registration">
                {this.state.userExists ? <SiteMenu user={this.state.user} currentPage='trainingMain' /> : <GuestSiteMenu currentPage='trainingMain' />}
                <Form onSubmit={this.handleSearch}  className="mb-3">

                    <Form.Group as={Row} controlId="searchForm" style={{ padding: '10px 10px 0px 10px' }}>
                        <Col md="auto" sm="auto" xs="auto">
                            <Form.Label style={{ paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '21px', color: '#1F419B', width: 'fit-content' }}>Upcoming Training Events</Form.Label><br />
                            <Form.Label style={{ fontSize: '15px', marginTop: '-5px', paddingTop: '0px', fontStyle: 'italic' }}>Below is a list of our upcoming training events. Click "Register" for more information and to register for yourself or on behalf of others. Please contact marketing@boland.com with questions on upcoming trainings.</Form.Label>
                        </Col>
                    </Form.Group>
                </Form>
                <BootstrapTable
                    bootstrap4
                    remote
                    keyField="Id"
                    data={availableData}
                    columns={availableColumns}
                    wrapperClasses="training-register-table"
                    //filter={filterFactory()}
                    striped
                    hover
                    noDataIndication={this.availableLoadingSpinner}
                    loading={this.state.availableLoading}
                    style={customStyle}
                    onTableChange={this.handleAvaialblTableChange}
                />
            </div>
        );
    }
}

export default TrainingMainTemp;